import {withTranslation} from '@wix/yoshi-flow-editor'
import {getEventId, getSlug} from '@wix/wix-events-commons-statics'
import {connect} from '../../runtime-context/context'
import {getInvoice} from '../../../selectors/placed-order'
import {getReservationExpiration, getReservationId} from '../../../selectors/reservation'
import {DetailsPageAppProps} from '../../app/interfaces'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {MobileCheckoutRuntimeProps} from './interfaces'
import {MobileCheckout as Presentation} from './mobile-checkout'

const mapRuntime = ({
  state,
  actions: {formPageLoaded, cancelReservation, openTicketsDetailsModal, openTimeExpiredModal, closeNativeModal},
}: DetailsPageAppProps): MobileCheckoutRuntimeProps => {
  const event = state.event
  return {
    eventId: getEventId(event),
    slug: getSlug(event),
    reservationId: getReservationId(state),
    reservationExpiration: getReservationExpiration(state),
    invoice: getInvoice(state),
    isMobile: isMobile(state),
    formPageLoaded,
    cancelReservation,
    openTicketsDetailsModal,
    openTimeExpiredModal,
    closeNativeModal,
  }
}

export const MobileCheckout = connect<{}, MobileCheckoutRuntimeProps>(mapRuntime)(withTranslation()(Presentation))
